/**
 * @generated SignedSource<<057c5ea17ce46441256618ac1c551769>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
export type GrowthRecContext = {
  anonymousId?: string | null | undefined;
  containers?: any | null | undefined;
  custom?: any | null | undefined;
  locale?: string | null | undefined;
  orgId?: string | null | undefined;
  product?: string | null | undefined;
  sessionId?: string | null | undefined;
  subproduct?: string | null | undefined;
  tenantId?: string | null | undefined;
  useCase?: string | null | undefined;
  userId?: string | null | undefined;
  workspaceId?: string | null | undefined;
};
export type templateRecommendationsSearchResultsRelayQuery$variables = {
  context: GrowthRecContext;
  first?: number | null | undefined;
};
export type templateRecommendationsSearchResultsRelayQuery$data = {
  readonly growthRecommendations: {
    readonly recommendations: {
      readonly data?: ReadonlyArray<{
        readonly entityId: string;
      }> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type templateRecommendationsSearchResultsRelayQuery = {
  response: templateRecommendationsSearchResultsRelayQuery$data;
  variables: templateRecommendationsSearchResultsRelayQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "context"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "context",
    "variableName": "context"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "templateRecommendationsSearchResultsRelayQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GrowthRecQuery",
        "kind": "LinkedField",
        "name": "growthRecommendations",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "recommendations",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "data",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "GrowthRecRecommendations",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "templateRecommendationsSearchResultsRelayQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GrowthRecQuery",
        "kind": "LinkedField",
        "name": "growthRecommendations",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "recommendations",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "data",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "GrowthRecRecommendations",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9f25c2b536fd6f308bf980a0838c8f9b",
    "id": null,
    "metadata": {},
    "name": "templateRecommendationsSearchResultsRelayQuery",
    "operationKind": "query",
    "text": "query templateRecommendationsSearchResultsRelayQuery(\n  $context: GrowthRecContext!\n  $first: Int\n) {\n  growthRecommendations {\n    recommendations(first: $first, context: $context) {\n      __typename\n      ... on GrowthRecRecommendations {\n        data {\n          __typename\n          entityId\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0a24908db2bde3aa7909e2f0f05204eb";

export default node;
